import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
  align-items: center;
  gap: 5px;

  > div {
    justify-content: center;
    align-items: center;
    display: flex;
  }

  // @media (max-width: 1500px) {
  //   > div {
  //     height: 60px;
  //     width: 60px;

  //     > img {
  //         height: 35px;
  //         width: 35px;
  //     }
  //   }
  // }

  // @media (max-width: 1300px) {
  //   > div {
  //     height: 50px;
  //     width: 50px;

  //     > img {
  //         height: 30px;
  //         width: 30px;
  //     }
  //   }
  // }

  // @media (max-width: 1100px) {
  //   > div {
  //     height: 45px;
  //     width: 45px;

  //     > img {
  //         height: 24px;
  //         width: 24px;
  //     }
  //   }
  // }


`
